import Loader from "../../common/components/Loader";
import { useOfferCalculatorState } from "../context/OfferCalculatorContext";
import ContractPeriodGrid from "./ContractPeriodGrid";
import DownpaymentStepper from "./DownpaymentStepper";
import FinancingTypeSegment from "./FinancingTypeSegment";
import ServicePackageToggles from "./ServicePackageToggles";
import React from "react";
export default function CalculatorCard() {
    const { isLoading, isReady, error } = useOfferCalculatorState();
    return (<div className="lg:rounded-xl lg:border lg:border-solid lg:border-[#A1A2A5] overflow-hidden">
      <div className="relative min-h-20 lg:p-5 py-8" aria-busy={isLoading}>
        {error ? (<p className="text-sm text-[#C82814]">
            Nie udało się wczytać kalkulatora.
          </p>) : null}
        {isReady ? (<div className={`lead-config-form flex flex-col space-y-4 ${isLoading ? "pointer-events-none select-none" : ""}`}>
            <FinancingTypeSegment />
            <ContractPeriodGrid />
            <hr className="border-t border-[#DDE2E4]"/>
            <DownpaymentStepper />
            <ServicePackageToggles />
          </div>) : null}
        {isLoading ? (<div className={`lead-config-loader absolute inset-0 z-10 flex items-center justify-center ${isReady ? "bg-white/80" : ""}`}>
            <Loader />
          </div>) : null}
      </div>
    </div>);
}
